<template>
    <div class="tab-pane" id="references" role="tabpanel" aria-labelledby="tab-references">
        <div class="card">
            <div class="card-header">
                Referencias

                <button class="btn btn-primary btn-raised float-right" @click="addReferenceModal()">
                    Agregar referencias
                </button>
            </div>
            <div class="card-body">
                <table class="table table-sm">
                    <thead class="thead-dark">
                        <th>ID</th>
                        <th>PID</th>
                        <th>Tipo</th>
                        <th>Tipo Relación</th>
                        <th>Nombre</th>
                        <th>Email</th>
                        <th>Telefono</th>
                        <th>RFC</th>
                        <th>Creado</th>
                        <th>Eliminar</th>
                    </thead>
                    <tbody>
                        <tr v-for="(reference, i) in references" v-bind:key="reference.id">
                            <td>{{reference.id}}</td>
                            <td>{{reference.project_id}}</td>
                            <td>{{projectReleatedProfilesType[reference.type] || "No definido"}}</td>
                            <td>{{projectReleatedProfilesRelationType[reference.relation_type] || "No definido"}}</td>
                            <td>{{reference.name}}</td>
                            <td>{{reference.email}}</td>
                            <td>{{reference.phone}}</td>
                            <td>{{reference.rfc}}</td>
                            <td>{{reference.created_at}}</td>
                            <td>
                                <button class="btn btn-sm btn-raised btn-outline-primary" @click="editModal(reference)">
                                    <em class="material-icons">edit</em>
                                </button>
                                <button class="btn btn-sm btn-raised btn-danger" @click="deleteConfirmation(reference.id, i)">
                                    <em class="material-icons">delete</em>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="modal fade" tabindex="-1" role="dialog" id="add_reference_modal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Agregar referencia</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form @submit.prevent="addReference()">
                    <div class="modal-body">

                        <div class="form-group">
                            <label>Tipo Referencia</label>
                            <select v-model="form.type" class="form-control">
                                <option
                                        v-if="(variant === 'contact-reference' && k != 1) || (variant === 'solidary' && k == 1)"
                                        :value="k"
                                        v-for="(v, k, i) in projectReleatedProfilesType"
                                        v-bind:key="i">
                                    {{v}}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Nombre completo</label>
                            <input v-model="form.name" class="form-control" />
                        </div>
                        <div class="form-group">
                            <label>Relación</label>
                            <select class="form-control" v-model="form.relation_type">
                                <option :value="k" v-for="(v, k, i) in projectReleatedProfilesRelationType" v-bind:key="i">
                                    {{v}}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Correo</label>
                            <input class="form-control" v-model="form.email" />
                        </div>
                        <div class="form-group">
                            <label>Teléfono</label>
                            <input class="form-control" v-model="form.phone" />
                        </div>

                        <template v-if="form.type == 1">
                            <div class="form-group">
                                <label>RFC</label>
                                <input class="form-control" v-model="form.rfc" />
                            </div>
                            <div class="form-group">
                                <template v-if="form.official_id_front_file == null">
                                    <label>ID Frente</label>
                                    <input type="file" class="form-control" ref="official_id_front_file" />
                                </template>
                                <template v-else>
                                    <a-secure
                                        :href="`${StorageURL}/storage/private/user/6117/releated_profiles/${form.official_id_front_file}?access_token=${user.access_token}`">
                                        {{form.official_id_front_file}}
                                    </a-secure>
                                </template>
                            </div>
                            <div class="form-group">
                                <template v-if="form.official_id_back_file == null">
                                    <label>ID Reverso</label>
                                    <input type="file" class="form-control" ref="official_id_back_file" />
                                </template>
                                <template v-else>
                                    <a-secure
                                        :href="`${StorageURL}/storage/private/user/6117/releated_profiles/${form.official_id_back_file}?access_token=${user.access_token}`">
                                        {{form.official_id_back_file}}
                                    </a-secure>
                                </template>
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="submit" class="btn btn-primary btn-raised" :disabled="controlConcurrence">Guardar</button>
                    </div>
                </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ProjectReleatedProfilesTypeEnum } from "../../../../bl/enums/ProjectReleatedProfilesTypeEnum";
    import { ProjectReleatedProfilesRelationTypeEnum } from "../../../../bl/enums/ProjectReleatedProfilesRelationTypeEnum";
    import { AxiosErrorException } from '../../functions/axiosErrorException';
    import swal from 'sweetalert';
    import { mapState } from 'vuex';
    import ASecure from "@components/utils/aSecure";

    export default {
        name: "tab-references",
      components: {ASecure},
      props: ['client_id', 'variant'],
        data() {
            return {
                references: [],
                controlConcurrence: false,
                form: {
                    type: "0",
                    name: "",
                    relation_type: "0",
                    email: "",
                    phone: "",
                    rfc: ""
                },
                projectReleatedProfilesType: [],
                projectReleatedProfilesRelationType: []
            }
        },
        computed: {
            ...mapState("auth", ["user"])
        },
        mounted() {
            this.getReferences();

            let PRPT = new ProjectReleatedProfilesTypeEnum();
            this.projectReleatedProfilesType = PRPT.toArray();

            let PRPRT = new ProjectReleatedProfilesRelationTypeEnum();
            this.projectReleatedProfilesRelationType = PRPRT.toArray()
        },
        methods: {
            addReferenceModal() {
                $("#add_reference_modal").modal("show")
            },
            async getReferences() {
                try {
                    let res = await axios.get(`/api/client/${this.client_id}/releated_profiles`)
                    this.references = res.data;
                } catch (err) {
                    swal('Ups!', AxiosErrorException(err), 'error')
                }
            },
            async addReference() {
                let PRPT = new ProjectReleatedProfilesTypeEnum();

                let FormDataRequest = new FormData();
                FormDataRequest.append('type', this.form.type);
                FormDataRequest.append('name', this.form.name);
                FormDataRequest.append('relation_type', this.form.relation_type);
                FormDataRequest.append('email', this.form.email);
                FormDataRequest.append('phone', this.form.phone);
                FormDataRequest.append('rfc', this.form.rfc);
                FormDataRequest.append('filters', { type: PRPT.OBLIGADO_SOLIDARIO });

                let official_id_front_file = this.$refs.official_id_front_file.files[0];
                let official_id_back_file = this.$refs.official_id_back_file.files[0];
                // let credit_review_authorization_file = this.$refs.credit_review_authorization_file.files[0];
                // let credit_report_file = this.$refs.credit_report_file.files[0];

                FormDataRequest.append('official_id_front_file', (official_id_front_file !== undefined) ? official_id_front_file : '');
                FormDataRequest.append('official_id_back_file', (official_id_back_file !== undefined) ? official_id_back_file : '');
                /* FormDataRequest.append('credit_review_authorization_file', (credit_review_authorization_file !== undefined) ? credit_review_authorization_file : '');
                FormDataRequest.append('credit_report_file', (credit_report_file !== undefined) ? credit_report_file : '');*/

                try {
                    this.controlConcurrence = true;

                    let res = await axios.post(
                        `/api/client/${this.client_id}/releated_profiles`,
                        FormDataRequest,
                        { headers: { "Content-Type": "multipart/form-data" } }
                    )
                    this.references.push(res.data);
                } catch(err) {
                    swal('Ups!', AxiosErrorException(err), 'error')
                } finally {
                    this.controlConcurrence = false
                }
            },
            deleteConfirmation(id, index) {
                if (confirm("Esta segura de eliminar esta referencia?")) {
                    this.deletePersonReleated(id, index);
                }
            },
            async deletePersonReleated(id, index) {
                try {
                    await axios.delete(`/api/client/${this.client_id}/releated_profiles/${id}`)
                    this.references.splice(index, 1)
                } catch (e) {
                    swal('Ups!', AxiosErrorException(e), 'error')
                }
            },
            editModal(reference) {
                this.form = reference
                $("#add_reference_modal").modal("show")
            }
        }
    }
</script>
